export default __webpack_public_path__ + "assets/MyriadPro-Regular.701f3ffd.svg";